// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"71":"6297ee3e41f30eb8","147":"15e00f04c5be8e59","220":"0031cfe554744233","469":"97dcdc6ad0181069","541":"c96e9a790d120fc0","733":"d5ad9e9b23e0e7f7"}[chunkId] + ".js";
};